/*@ngInject*/
const DeclineSubmissionRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.decline = function (submissionId) {
        var url = '/rest/Submission/' + submissionId + '/declineWithForm',
            config = {
                headers: {
                    'Content-Type': 'application/json'
                }
            };

        return this.post(url, {}, config);
    };

    this.createDeclinationForm = function (submissionId) {
        var url = '/rest/Submission/' + submissionId + '/declinationForm',
            config = {
                headers: {
                    'Content-Type': 'application/json'
                }
            };

        return this.post(url, {}, config);
    }

    this.deleteDeclinationForm = function (submissionId) {
        var url = '/rest/Submission/' + submissionId + '/declinationForm';

        return this.delete(url);
    }
};

angular.module('gw-um-submission')
    .service('declineSubmissionRepository', DeclineSubmissionRepository);
